import { ACCESS_TOKEN, useLocalStorage } from '@hsp/react-hooks';
import { IAuthenticationToken, isNotDefined } from '@hsp/utilities';

import { customEvents } from 'constants/custom-events';
import { authenticationService } from 'services';
import { TokenMissingError } from 'types/errors';
import { publishCustomEvent } from 'utilities/events';

export const useRefreshToken = () => {
  const [token, setToken] = useLocalStorage<IAuthenticationToken>(ACCESS_TOKEN, null);

  const refresh = async () => {
    if (isNotDefined(token)) {
      throw new TokenMissingError();
    }

    const response = await authenticationService.refreshToken(token);

    if (isNotDefined(response)) {
      publishCustomEvent(customEvents.logOffEvent);

      return;
    }

    setToken(response);

    return response;
  };

  return refresh;
};
